import React from "react"
import PropTypes from "prop-types"
import { Col, Button, Modal, Form } from "react-bootstrap"
import { Formik } from "formik"
import { string, object } from "yup"
import { useTranslation } from "react-i18next"
import IconPicker from "../../../../components/iconPicker"

const validationSchema = t => {
  return object().shape(
    {
      titleFi: string()
        .when(["titleEn"], {
          is: titleEn => !titleEn,
          then: () => string().required(t("common.validation.eitherRequired")),
        })
        .max(160, t("common.validation.invalidMaxTopicLength")),
      titleEn: string()
        .when(["titleFi"], {
          is: titleFi => !titleFi,
          then: () => string().required(t("common.validation.eitherRequired")),
        })
        .max(160, t("common.validation.invalidMaxTopicLength")),
      icon: string().required(t("common.validation.required")),
    },
    [["titleFi", "titleEn"]]
  )
}

const GuideModal = ({ data, show, onSubmit, onCancel }) => {
  const { t } = useTranslation()

  return (
    <Modal show={show} onHide={onCancel} backdrop="static">
      <Formik
        key={"Formik-edit-guide"}
        enableReinitialize={true}
        initialValues={{
          icon: (data && data.icon) || "body",
          titleEn: (data && data.titleEn) || "",
          titleFi: (data && data.titleFi) || "",
          isDraft: (data && data.isDraft) || false,
        }}
        validationSchema={validationSchema(t)}
        onSubmit={values => onSubmit(values)}>
        {({ handleSubmit, ...props }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Modal.Header closeButton>
              <Modal.Title>{data ? t("guides.modal.title.edit") : t("guides.modal.title.create")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Row>
                <IconPicker
                  type="text"
                  name="icon"
                  values={props.values}
                  handleChange={props.handleChange}
                  handleBlur={props.handleBlur}
                  isInvalid={props.touched.icon && props.errors.icon}
                />
              </Form.Row>
              <Form.Row>
                <Form.Group as={Col} xs={12} controlId="AddNewGuideFormtitleFi" className="position-relative">
                  <Form.Text className="text-muted">{t("guides.form.titleFi")}</Form.Text>
                  <Form.Control
                    type="text"
                    name="titleFi"
                    placeholder=""
                    onChange={props.handleChange}
                    onBlur={props.handleBlur}
                    defaultValue={props.values.titleFi}
                    isInvalid={props.touched.titleFi && props.errors.titleFi}
                  />
                  <Form.Control.Feedback tooltip type="invalid">
                    {props.errors.titleFi}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} xs={12} controlId="AddNewGuideFormtitleEn" className="position-relative">
                  <Form.Text className="text-muted">{t("guides.form.titleEn")}</Form.Text>
                  <Form.Control
                    type="text"
                    name="titleEn"
                    placeholder=""
                    onChange={props.handleChange}
                    onBlur={props.handleBlur}
                    defaultValue={props.values.titleEn}
                    isInvalid={props.touched.titleEn && props.errors.titleEn}
                  />
                  <Form.Control.Feedback tooltip type="invalid">
                    {props.errors.titleEn}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} xs={12} controlId="AddNewGuideFormIsDraft" className="position-relative">
                  <Form.Text className="text-muted">{t("guides.form.isDraft")}</Form.Text>
                  <Form.Check
                    type="switch"
                    id="isDraft"
                    name="isDraft"
                    onChange={e => props.setFieldValue("isDraft", !e.target.checked)}
                    checked={!props.values.isDraft}
                    label={props.values.isDraft ? t("guides.form.draft") : t("guides.form.publish")}
                  />
                </Form.Group>
              </Form.Row>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" className="btn-default" onClick={onCancel}>
                {t("guides.button.cancel")}
              </Button>
              <Button variant="primary" className="btn-default" type="submit">
                {t("guides.button.save")}
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

GuideModal.propTypes = {
  show: PropTypes.bool.isRequired,
  data: PropTypes.shape(),
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}

GuideModal.defaultProps = {
  data: null,
}

export default GuideModal
